import React, { useState } from 'react';
import { Typography, List, Tag, Space, Button, Modal, message } from 'antd';
import { CalendarOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import moment from 'moment';
import { mockPosts } from '../../api/mockData';

const { Title } = Typography;

const Archive = () => {
  const [posts, setPosts] = useState(mockPosts);
  const [editingPost, setEditingPost] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);

  // 按年月分组
  const groupedPosts = posts.reduce((groups, post) => {
    const yearMonth = moment(post.date).format('YYYY年MM月');
    if (!groups[yearMonth]) {
      groups[yearMonth] = [];
    }
    groups[yearMonth].push(post);
    return groups;
  }, {});

  const handleEdit = (post) => {
    setEditingPost(post);
    setIsModalVisible(true);
  };

  const handleDelete = (postId) => {
    Modal.confirm({
      title: '确认删除',
      content: '确定要删除这篇文章吗？',
      onOk: () => {
        setPosts(posts.filter(post => post.id !== postId));
        message.success('文章删除成功');
      },
    });
  };

  const handleSave = (updatedPost) => {
    setPosts(posts.map(post => 
      post.id === updatedPost.id ? updatedPost : post
    ));
    setIsModalVisible(false);
    message.success('文章更新成功');
  };

  return (
    <div>
      <Title level={2}>文章归档</Title>
      
      {Object.entries(groupedPosts)
        .sort((a, b) => b[0].localeCompare(a[0]))
        .map(([yearMonth, monthPosts]) => (
          <div key={yearMonth} style={{ marginBottom: 32 }}>
            <Title level={3} className="archive-year">{yearMonth}</Title>
            <List
              dataSource={monthPosts}
              renderItem={post => (
                <List.Item
                  actions={[
                    <Button 
                      type="text" 
                      icon={<EditOutlined />} 
                      onClick={() => handleEdit(post)}
                    >
                      编辑
                    </Button>,
                    <Button 
                      type="text" 
                      danger 
                      icon={<DeleteOutlined />}
                      onClick={() => handleDelete(post.id)}
                    >
                      删除
                    </Button>
                  ]}
                >
                  <List.Item.Meta
                    title={
                      <a href={`/post/${post.id}`} style={{ fontSize: 16 }}>
                        {post.title}
                      </a>
                    }
                    description={
                      <Space>
                        <CalendarOutlined />
                        <span>{moment(post.date).format('MM-DD')}</span>
                        {post.tags.map(tag => (
                          <Tag key={tag} color="blue">{tag}</Tag>
                        ))}
                      </Space>
                    }
                  />
                </List.Item>
              )}
            />
          </div>
        ))}
      
      {/* 编辑文章弹窗 */}
      <Modal
        title="编辑文章"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        width={800}
      >
        {editingPost && (
          <div>
            {/* 这里可以放置文章编辑表单 */}
            <p>编辑文章功能实现中...</p>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default Archive;